import React, { useState, useEffect, useRef } from "react";
import UploadFileModal from "./UploadFileModal";
import UploadSignatureModal from "./UploadSignatureModal";
import UploadINEModal from "./UploadINEModal";
import { useQueryClient } from "react-query";
import { useParams, useHistory } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
import { Input } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { toast } from "react-toastify";
import {
  faPlus,
  faTrash,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronRight,
  faChevronLeft,
  faFile,
} from "@fortawesome/free-solid-svg-icons";
import SignUpFormContainer from "../../SignUpForm";
import useFileUpload from "../../../api/hooks/useFileUpload";
import {
  useFetchCopyright,
  useCreateCopyright,
  useUpdateCopyright,
} from "../../../api/hooks/copyright";
import ContinueModal from "../../NewEditor/ContinueModal";
import { useTranslation } from "react-i18next";
import LoadingButton from "../../LoadingButton";
import UploadProgressBar from "../../ProgressBar";

function AutoriaForm() {
  const { t } = useTranslation();
  const history = useHistory();
  const queryClient = useQueryClient();
  let { elementID } = useParams();
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [fileSRC, setFileSRC] = useState("");
  const [INEfrontSRC, setINEfrontSRC] = useState("");
  const [INEreverseSRC, setINEreverseSRC] = useState("");
  const [signaturePic, setSignaturePic] = useState(null);
  const [ine1, setIne1] = useState(null);
  const [ine2, setIne2] = useState(null);
  const [mainFile, setmainfile] = useState(null);

  const { register, errors, handleSubmit, reset } = useForm();
  const methods = useForm({ mode: "all" });
  const [entradas, setentradas] = useState(undefined);
  const [files, setFiles] = useState([]);
  const [resumeLenght, setResumeLenght] = useState(0);
  const [category, setCategory] = useState("");
  const [parsedData, setparsedData] = useState(undefined);
  const [filesSources, setFilesSources] = useState([]);
  const [deleteAuthorID, setDeleteAuthorID] = useState(undefined);
  const [uploadedSize, setUploadedSize] = useState(0);
  const [totalSizeToUpload, settotalSizeToUpload] = useState(0);
  const [customProgress, setCustomProgress] = useState(undefined);
  const [totalToLoad, setTotalToLoad] = useState(undefined);

  const onProgress = (progressEvent) => {
    setUploadedSize((x) => x + progressEvent.loaded);
  };

  const { uploadFile, uploadFileState } = useFileUpload({
    onSuccess: ({ url, BaseFileName, fileId }) => {
      console.log(fileId);
      setTotalToLoad((totalToLoad) => totalToLoad - 1);
      setFilesSources((x) => [...x, { [`${BaseFileName}`]: url }]);
    },
    onError: (error) => {
      toast.error("Error al subir los Archivos");
    },
    onUploadProgress: onProgress,
  });
  const procesarFormulario = (data) => {
    console.log("procesarFormulario");
    setentradas(data);
    uploadAllFiles();

    setIsLoadingButton("loading");
    const numberOfUploads = filesToUpload.filter(
      (item) => !item?.pic?.isUploaded
    ).length;
    console.log("toUpload", numberOfUploads);
    setTotalToLoad(numberOfUploads);
    // console.log(numberFiles, "numberOfUploads", filesToUpload);
    // setNumberOfUploads(numberFiles + 1);
    // const uploads = new Array(numberFiles + 1).join("0").split("");
    // console.log("uploads", uploads);
    // setUploads(uploads);
  };

  const uploadAllFiles = () => {
    filesToUpload.map((item, i) => {
      if (!item?.pic?.isUploaded) {
        const renamedFile = new File(
          [item?.pic],
          item?.id +
            `${
              item?.pic?.type?.slice(0, 5) === "image" &&
              item?.id !== "mainfile"
                ? ".jpg"
                : `.${item?.pic?.type?.split("/")?.[1] || ".jpg"}`
            }`
        );

        console.log("renamedFile", renamedFile);
        uploadFile({ file: renamedFile });
        item.isUploaded = true;
        setFilesToUpload([...filesToUpload]);
        settotalSizeToUpload(totalSizeToUpload + item?.pic?.size);
      }
    });
    setFilesSources((x) => [...x, ""]);
  };

  const { mutate: mutateCreateCopyright } = useCreateCopyright({
    onSuccess: () => {
      if (validation) {
        toast.success(t("services.mutations.0"));
        history.push("/services/autorship-proof/created");
        setIsLoadingButton(false);
        setCustomProgress(100);
      }
      if (!validation) {
        toast.success(t("services.mutations.2"));
        history.push("/services/autorship-proof/in-process");
        setIsLoadingButton(false);
        setCustomProgress(100);
      }
    },
    onError: (error) => {
      toast.error(`${error}`);
      console.log(error);
      setIsLoadingButton(false);
      refetch();
    },
  });
  const { mutate: mutateUpdateCopyright } = useUpdateCopyright({
    onSuccess: (data, copyright) => {
      console.log(data, "useMutation Data");
      queryClient.setQueryData(["copyrights", copyright._id], () => copyright);
      if (validation) {
        toast.success(t("services.mutations.1"));
        setentradas(undefined);
        setIsLoadingButton(false);
        setTimeout(() => {
          history.push("/services/autorship-proof/created");
        }, 300);
        setCustomProgress(100);
      }
      if (!validation) {
        toast.success(t("services.mutations.3"));
        setCustomProgress(100);

        setentradas(undefined);
        setIsLoadingButton(false);
        setTimeout(() => {
          history.push("/services/autorship-proof/in-process");
        }, 300);
      }
    },
    onError: (error) => {
      toast.error(`${error}`);
      console.log(error);
      setentradas(undefined);
      setIsLoadingButton(false);
      refetch();
    },
  });
  const getFinalData = (data) => {
    const getFile = (id) => {
      console.log(id, "fileToSearch");
      const element = filesSources?.filter(
        (item) => item[id] !== undefined
      )?.[0]?.[id];
      return element;
    };

    const getFileObj = (id) => {
      console.log(filesToUpload);
      const element = filesToUpload?.filter((x) => x?.id === id);

      return element[0]?.pic?.type?.split("/")?.[1];
    };
    const parseAutors = authors?.map((item) => {
      console.log(getFile(`id${item?.id}`));
      const newObj = {
        id: item.id,
        name: data[`author${item?.id}`],
        curp: data[`curp${item?.id}`],
        email: data[`email${item?.id}`],
        ine: [getFile(`id${item?.id}.jpg`), getFile(`id2${item?.id}.jpg`)],
      };

      console.log(newObj);

      return newObj;
    });
    let autores = parseAutors;
    console.log(mainFile?.type?.split("/")?.[1]);
    console.log(mainFile?.type?.split("/"));

    let parsedData = {
      authors: autores,
      name: data?.title,
      category: data?.categoryOther ? data?.categoryOther : data?.category,
      description: data?.description,

      signature: getFile(`signaturepic.jpg`),
      signatureRepresentant: {
        author: data?.signatureRepresentant,
        workname: data?.signatureWorkName,
        date: data?.signatureRepresentantDate,
        message: `${data?.signatureRepresentant} firma en representación de los autores de la Obra ${data?.signatureWorkName} el ${data?.signatureRepresentantDate}`,
      },
      file: getFile(`mainfile.${mainFile?.type?.split("/")?.[1]}`),

      mainFileData: {
        name: mainFile?.name,
        type: mainFile?.type,
        size: mainFile?.size,
        src: getFile(`mainfile.${mainFile?.type?.split("/")?.[1]}`) || "",
        isUploaded: true,
      },
      isValidated: validation,
    };

    if (elementID) {
      mutateUpdateCopyright({
        id: elementID,
        body: parsedData,
        onUploadProgress: onProgress,
      });
    }
    if (!elementID) {
      mutateCreateCopyright({ body: parsedData, onUploadProgress: onProgress });
    }
  };

  // useEffect(() => {
  //   if (isLoadingButton === "readyToSend" && filesSources && entradas) {
  //     getFinalData(entradas);
  //   }
  // }, [isLoadingButton, filesSources, entradas]);
  // useEffect(() => {
  //   console.log(entradas);
  //   if (entradas) {
  //     uploadAllFiles();
  //   }
  // }, [entradas]);

  const [authors, setAuthors] = useState([{ id: `a${Date.now()}` }]);

  const [activeID, setActiveID] = useState(0);
  const [dropdown, setDropdown] = useState(false);
  const [validation, setValidation] = useState(null);

  useEffect(() => {
    console.log(authors);
  }, [authors]);

  const deleteElement = (id) => {
    if (authors.length > 1) {
      let newArr = authors?.filter((x) => x?.id !== id);
      console.log(newArr);
      console.log(id);
      setAuthors(newArr);
    }
    const updatedFilesToUpload = filesToUpload.filter(
      (x) => x.id !== `id${id}` && x.id !== `id2${id}`
    );
    setFilesToUpload(updatedFilesToUpload);
  };
  const deleteFile = (id, type) => {
    console.log("type", type);
    const updatedFilesToUpload = filesToUpload.filter((x) => x.id !== id);
    setFilesToUpload(updatedFilesToUpload);
    const updatedFilesSources = filesSources?.filter(
      (item) => !item[`${id}.${type || "jpg"}`]
    );
    console.log(updatedFilesSources);
    setFilesSources(updatedFilesSources);
  };

  const getFile = (id) => {
    const selectedFile = filesToUpload.filter((x) => x.id === id)?.[0];

    return selectedFile?.pic || null;
  };
  const createElement = () => {
    let newElement = { id: `a${Date.now()}` };
    setAuthors(authors.concat(newElement));
  };
  useEffect(() => {
    if (activeID + 1 > authors.length) {
      setActiveID(authors.length - 1);
    }
  }, [authors, activeID]);
  useEffect(() => {
    if (errors && validation) {
      setIsLoadingButton(false);
    }
  }, [errors]);
  const categoryList = [
    t("services.copyright.form.category.0"),
    t("services.copyright.form.category.1"),
    t("services.copyright.form.category.2"),
    t("services.copyright.form.category.3"),
    t("services.copyright.form.category.4"),
    t("services.copyright.form.category.5"),
    t("services.copyright.form.category.6"),
    t("services.copyright.form.category.7"),
    t("services.copyright.form.category.8"),
    t("services.copyright.form.category.9"),
    t("services.copyright.form.category.10"),
  ];
  const [filesToUpload, setFilesToUpload] = useState([]);
  useEffect(() => {
    console.log("filesToUpload", filesToUpload);
  }, [filesToUpload]);

  useEffect(() => {
    if (signaturePic !== null && !signaturePic?.isUploaded) {
      setFilesToUpload((x) => [
        ...x,
        { id: "signaturepic", pic: signaturePic },
      ]);
    }
  }, [signaturePic]);
  useEffect(() => {
    if (mainFile !== null && !mainFile?.isUploaded) {
      let newElement = { id: "mainfile", pic: mainFile };
      setFilesToUpload((x) => [newElement, ...x]);
    }
  }, [mainFile]);
  useEffect(() => {
    console.log(filesSources);
  }, [filesSources]);

  //edition
  const [defaultValues, setDefaultValues] = useState(null);

  const {
    isLoading,
    isFetching,
    data = {},
    refetch,

    error,
  } = useFetchCopyright(elementID);
  useEffect(() => {
    if (data.authors) {
      setDefaultValues(data);
      console.log("data", elementID, data);
    }
  }, [data]);
  const getURLFileSize = async (url) => {
    let size;
    await fetch(url)
      .then((response) => response.arrayBuffer())
      .then((buffer) => (size = buffer.byteLength))
      .catch((err) => console.log(err));
    console.log(size);
    return size;
  };

  useEffect(() => {
    if (defaultValues && defaultValues !== null) {
      setAuthors(defaultValues?.authors);
      setCategory(defaultValues?.category);
      if (defaultValues?.file) {
        setmainfile(defaultValues?.mainFileData);
      }
      if (defaultValues.authors) {
        defaultValues.authors.map(async (x) => {
          if (x?.ine?.[0]) {
            let id = x?.id;
            let ine = x.ine[0];
            let fileSize = await getURLFileSize(ine);

            setFilesSources((x) => [...x, { [`id${id}.jpg`]: ine }]);
            setFilesToUpload((x) => [
              ...x,
              {
                id: "id" + id,

                pic: {
                  name: ine.split("/").pop(),
                  isUploaded: true,
                  url: ine,
                  size: fileSize,
                },
              },
            ]);
          }
          if (x?.ine?.[1]) {
            let id = x?.id;
            let ine = x.ine[1];
            let fileSize = await getURLFileSize(ine);
            setFilesSources((x) => [...x, { [`id2${id}.jpg`]: ine }]);
            setFilesToUpload((x) => [
              ...x,
              {
                id: "id2" + id,

                pic: {
                  name: ine.split("/").pop(),
                  isUploaded: true,
                  url: ine,
                  size: fileSize,
                },
              },
            ]);
          }
        });
      }
      if (defaultValues?.file) {
        setFilesSources((x) => [
          ...x,
          {
            [`mainfile.${defaultValues?.mainFileData?.type?.split("/")?.[1]}`]:
              defaultValues?.file,
          },
        ]);
      }
      if (defaultValues?.signature) {
        const url = defaultValues?.signature;
        setFilesSources((x) => [...x, { ["signaturepic.jpg"]: url }]);
        setSignaturePic({ url });
        setFilesToUpload((x) => [
          ...x,
          { id: "signaturePic", pic: { isUploaded: true, url } },
        ]);
      }
    }
  }, [defaultValues]);

  //Upload

  useEffect(() => {
    console.log(totalToLoad, "totalToLoad");
  }, [totalToLoad]);

  const timeout = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  useEffect(() => {
    let isNotFinalState = false;
    console.log("allRenders", filesSources);
    const handleChange = async () => {
      await timeout(1000);

      if (!isNotFinalState) {
        if (
          entradas &&
          filesSources?.length > 0 &&
          (totalToLoad === 0 || filesToUpload.length === 0)
        ) {
          getFinalData(entradas);
          console.log("lastRenders", filesSources);
          console.log("lastRenders", entradas);
        }
      }
    };
    handleChange();
    return () => {
      isNotFinalState = true;
    };
  }, [filesSources]);

  useEffect(() => {
    console.log(entradas, "entrys");
  }, [entradas]);
  return (
    <div className="autoria--main--form">
      <div className="headerAutoria pb-4">
        <h2>{t("services.copyright.form.title")}</h2>
      </div>
      {/* {() => deleteElement(item?.id)} */}
      <UploadProgressBar
        loaded={uploadedSize}
        totalToUpload={totalSizeToUpload}
        forCopyright={true}
      />
      <ContinueModal
        toggle={deleteAuthorID}
        handleClose={() => setDeleteAuthorID(undefined)}
        handleContinue={() => {
          deleteElement(deleteAuthorID);
          setDeleteAuthorID(undefined);
        }}
        confirmationText={t("services.copyright.deleteModal.text")}
        headerText={t("services.copyright.deleteModal.text2")}
        continueButton={t("services.copyright.deleteModal.text2")}
        cancelButton={t("services.copyright.deleteModal.text3")}
      />
      <form
        className="autoria--main--form--column"
        onSubmit={handleSubmit(procesarFormulario)}
      >
        <UploadFileModal
          isOpen={modal1}
          toggle={() => setModal1(!modal1)}
          loadFile={(e) => setmainfile(e)}
        />
        <UploadSignatureModal
          isOpen={modal2}
          toggle={() => setModal2(!modal2)}
          loadFile={(e) => setSignaturePic(e)}
        />

        <div className="autoria----form--item">
          <div className="d-flex">
            <h3>{t("services.copyright.form.author.title")}</h3>
            <div
              onClick={(e) => {
                e.preventDefault();

                createElement();
              }}
              className="addAuthorButton"
            >
              <FontAwesomeIcon icon={faPlus} color="#f37b33" />
            </div>
          </div>

          {authors.length > 0 &&
            authors.map((item, i) => (
              <div
                className="formContainer"
                key={item.id}
                hidden={activeID !== i}
              >
                <UploadINEModal
                  isOpen={modal3 === item?.id}
                  toggle={() => setModal3(!modal3)}
                  id={item?.id}
                  handleLoadFile={(e) => setFilesToUpload((x) => [...x, e])}
                  deleteElement={(e) => deleteFile(e)}
                  file1={getFile(`id${item.id}`)}
                  file2={getFile(`id2${item.id}`)}
                />
                {authors.length > 1 && (
                  <div
                    onClick={() => setDeleteAuthorID(item?.id)}
                    className="deleteElementButton"
                  >
                    <FontAwesomeIcon icon={faTrash} color="#545454" />
                  </div>
                )}
                <div className="formElement">
                  <label htmlFor="">
                    {t("services.copyright.form.author.name")}
                  </label>
                  <input
                    type="text"
                    id={`author${item?.id}`}
                    name={`author${item?.id}`}
                    defaultValue={item?.name}
                    ref={register({
                      required: {
                        value: validation,
                        message: t("services.copyright.form.validation.0"),
                      },
                    })}
                  />
                  <span className="text-danger text-small d-block mb-2">
                    {errors[`author${item.id}`]?.message}
                  </span>
                </div>

                <div className="formElement">
                  <label htmlFor="">
                    {t("services.copyright.form.author.curp")}
                  </label>
                  <input
                    type="text"
                    name={`curp${item?.id}`}
                    id={`curp${item?.id}`}
                    defaultValue={item?.curp}
                    ref={register({
                      required: {
                        value: validation,

                        message: t("services.copyright.form.validation.0"),
                      },

                      minLength: {
                        value: validation ? 18 : 0,

                        message: "curp invalido",
                      },
                      maxLength: {
                        value: validation ? 18 : undefined,
                        message: "curp invalido",
                      },
                    })}
                  />
                  <span className="text-danger text-small d-block mb-2">
                    {errors[`curp${item.id}`]?.message}
                  </span>
                </div>

                <div className="formElement">
                  <label htmlFor="">
                    {t("services.copyright.form.author.email")}
                  </label>
                  <input
                    type="text"
                    name={`email${item?.id}`}
                    defaultValue={item?.email}
                    ref={register({
                      required: {
                        value: validation,
                        message: t("services.copyright.form.validation.0"),
                      },
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        message: "Email invalido",
                      },
                    })}
                  />
                  <span className="text-danger text-small d-block mb-2">
                    {errors[`email${item?.id}`]?.message}
                  </span>
                </div>
                <div className="formElement">
                  <label htmlFor="">
                    {t("services.copyright.form.author.ine")}
                  </label>
                  <div className="d-flex">
                    {getFile(`id${item?.id}`) && (
                      <div className="d-flex mainFileInfo mainFileInfoSmall">
                        <div className="d-flex">
                          <FontAwesomeIcon
                            icon={faFile}
                            size="1x"
                            color="#9ea0a5"
                            className="ImageIcon"
                          />
                          <p>
                            {getFile(`id${item?.id}`)?.name?.length > 10
                              ? `${getFile(`id${item?.id}`)?.name?.slice(
                                  0,
                                  10
                                )}...`
                              : getFile(`id${item?.id}`)?.name}
                          </p>

                          <span>
                            {String(
                              getFile(`id${item?.id}`)?.size / 1024 ** 2
                            ).slice(0, 5)}{" "}
                            MB
                          </span>
                        </div>
                        {getFile(`id2${item?.id}`) && (
                          <div className="d-flex">
                            <FontAwesomeIcon
                              icon={faFile}
                              size="1x"
                              color="#9ea0a5"
                              className="ImageIcon"
                            />
                            <p>
                              {getFile(`id2${item?.id}`)?.name?.length > 10
                                ? `${getFile(`id2${item?.id}`)?.name?.slice(
                                    0,
                                    10
                                  )}...`
                                : getFile(`id2${item?.id}`)?.name}
                            </p>

                            <span>
                              {String(
                                getFile(`id2${item?.id}`)?.size / 1024 ** 2
                              ).slice(0, 5)}{" "}
                              MB
                            </span>
                          </div>
                        )}
                        <button
                          className="button"
                          onClick={(e) => {
                            e.preventDefault();
                            setModal3(item?.id);
                          }}
                        >
                          {t("services.copyright.form.author.changeIne")}
                        </button>
                      </div>
                    )}
                    {!getFile(`id${item?.id}`) && (
                      <button
                        className="button"
                        onClick={(e) => {
                          e.preventDefault();
                          setModal3(item?.id);
                        }}
                      >
                        {t("services.copyright.form.author.uploadIne")}
                      </button>
                    )}
                  </div>

                  <input
                    type="text"
                    name={`id${item?.id}`}
                    defaultValue={getFile(`id${item?.id}`) ? "filled" : ""}
                    ref={register({
                      required: {
                        value: validation,
                        message: t("services.copyright.form.validation.1"),
                      },
                    })}
                    hidden={true}
                  />
                  <input
                    type="text"
                    name={`id2${item?.id}`}
                    defaultValue={getFile(`id2${item?.id}`) ? "filled" : ""}
                    ref={register({
                      required: {
                        value: validation,
                        message: t("services.copyright.form.validation.1"),
                      },
                    })}
                    hidden={true}
                  />
                  <span className="text-danger text-small d-block mb-2">
                    {(!getFile(`id${item?.id}`) &&
                      errors[`id${item?.id}`]?.message) ||
                      ""}
                  </span>
                  <span className="text-danger text-small d-block mb-2">
                    {(!getFile(`id2${item?.id}`) &&
                      errors[`id2${item?.id}`]?.message) ||
                      ""}
                  </span>
                </div>
              </div>
            ))}
          {authors.length > 1 && (
            <div className="d-flex controlsContainer">
              <div
                className="left"
                onClick={(e) => {
                  e.preventDefault();
                  if (activeID > 0) {
                    setActiveID(activeID - 1);
                  }
                  if (activeID === 0) {
                    setActiveID(authors?.length - 1);
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  color="#f37b33"
                  size="2x"
                />
              </div>
              <div className="indicators">
                {authors?.map((item, index) => (
                  <div
                    className={
                      activeID === index ? "dot active" : "dot unActive"
                    }
                  ></div>
                ))}
              </div>
              <div
                className="right"
                onClick={(e) => {
                  e.preventDefault();
                  if (activeID < authors.length - 1) {
                    setActiveID(activeID + 1);
                  }
                  if (activeID === authors.length - 1) {
                    setActiveID(0);
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={faChevronRight}
                  color="#f37b33"
                  size="2x"
                />
              </div>
            </div>
          )}
        </div>
        <div className="autoria----form--item">
          <h3>{t("services.copyright.form.work.title")}</h3>
          <div className="formContainer">
            <div className="formElement">
              <label htmlFor="">{t("services.copyright.form.work.name")}</label>
              <input
                type="text"
                name="title"
                defaultValue={defaultValues?.name || ""}
                ref={register({
                  required: {
                    value: validation,
                    message: t("services.copyright.form.validation.0"),
                  },
                })}
              />
              <span className="text-danger text-small d-block mb-2">
                {errors?.title?.message}
              </span>
            </div>

            <div className="formElement ">
              <label htmlFor="">
                {t("services.copyright.form.work.category")}
              </label>
              <div className="categoryDrop">
                <div className="dropdown">
                  <div
                    className="button"
                    onClick={() => setDropdown(!dropdown)}
                  ></div>
                  {dropdown === true && (
                    <div className="select">
                      {categoryList.map((item) => (
                        <div
                          onClick={() => {
                            setCategory(item);
                            setDropdown(false);
                          }}
                        >
                          {item}
                        </div>
                      ))}
                    </div>
                  )}
                  {(category === "Otro" || category === "Other") && (
                    <div className="input">
                      <input
                        type="text"
                        name="categoryOther"
                        ref={register({
                          required: {
                            value: validation,
                            message: t("services.copyright.form.validation.0"),
                          },
                        })}
                      />
                      <span className="text-danger text-small d-block mb-2">
                        {errors?.categoryOther?.message}
                      </span>
                    </div>
                  )}
                </div>
                <input
                  type="text"
                  name="category"
                  defaultValue={category}
                  ref={register({
                    required: {
                      value: validation,
                      message: t("services.copyright.form.validation.0"),
                    },
                  })}
                />
              </div>
              <span className="text-danger text-small d-block mb-2">
                {(category?.length < 1 && errors?.category?.message) || ""}
              </span>
            </div>
            <div className="formElement ">
              <label htmlFor="">
                {t("services.copyright.form.work.description")}
              </label>
              <textarea
                name="description"
                maxLength={320}
                onChange={(e) => setResumeLenght(e.target?.value?.length)}
                defaultValue={defaultValues?.description || ""}
                placeholder={t("services.copyright.form.work.placeholder")}
                ref={register({
                  required: {
                    value: validation,
                    message: t("services.copyright.form.validation.0"),
                  },
                })}
              />
              <span className="d-block mb-2">{resumeLenght}/320</span>
              <span className="text-danger text-small d-block mb-2">
                {errors?.description?.message}
              </span>
            </div>
            <div className="formElement "></div>
          </div>
        </div>

        <div className="autoria----form--item">
          <h3>{t("services.copyright.form.file.button")}</h3>
          {mainFile !== null && (
            <div className="d-flex mainFileInfo">
              <div className="d-flex">
                <FontAwesomeIcon
                  icon={faFile}
                  size="1x"
                  color="#9ea0a5"
                  className="ImageIcon"
                />
                <p>
                  {mainFile?.name?.length > 40
                    ? `${mainFile?.name?.slice(0, 40)}...`
                    : mainFile?.name}
                </p>

                <span>{String(mainFile?.size / 1024 ** 2).slice(0, 5)} MB</span>
              </div>

              <FontAwesomeIcon
                icon={faTrash}
                size={"1x"}
                color="#9ea0a5"
                className="deleteElement"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setmainfile(null);
                  deleteFile("mainfile", mainFile?.type?.split("/")?.[1]);
                }}
              />
            </div>
          )}
          <button
            className="button"
            onClick={(e) => {
              e.preventDefault();
              setModal1(true);
            }}
          >
            {mainFile === null
              ? t("services.copyright.form.file.title")
              : t("services.copyright.form.file.buttonAlt")}
          </button>
          <input
            type="text"
            name="file"
            defaultValue={mainFile ? "filled" : ""}
            ref={register({
              required: {
                value: validation,
                message: t("services.copyright.form.validation.2"),
              },
            })}
            hidden={true}
          />
          <span className="text-danger text-small d-block mb-2">
            {(!mainFile && errors?.file?.message) || ""}
          </span>
        </div>
        <div className="autoria----form--item">
          <h3>{t("services.copyright.form.signature.title")}</h3>
          {signaturePic !== null && (
            <img
              alt="not fount"
              width={280}
              src={
                signaturePic?.url
                  ? signaturePic?.url
                  : URL.createObjectURL(signaturePic)
              }
              style={{ margin: "0px auto" }}
            />
          )}
          <button
            className="button"
            onClick={(e) => {
              e.preventDefault();
              setModal2(true);
              deleteFile("signaturepic");
            }}
          >
            {signaturePic === null
              ? t("services.copyright.form.signature.button")
              : t("services.copyright.form.signature.buttonAlt")}
          </button>
          <input
            type="text"
            name="signatureSRC"
            defaultValue={signaturePic ? "filled" : ""}
            ref={register({
              required: {
                value: validation,
                message: t("services.copyright.form.validation.3"),
              },
            })}
            hidden={true}
          />
          <span className="text-danger text-small d-block mb-2">
            {(!signaturePic && errors?.signatureSRC?.message) || ""}
          </span>
          {authors.length > 1 && (
            <div className="signatureRepresentantForm">
              <div>
                <input
                  type="text"
                  className="name"
                  placeholder="Nombre completo del firmante"
                  name="signatureRepresentant"
                  defaultValue={
                    defaultValues?.signatureRepresentant?.author || ""
                  }
                  ref={register({
                    required: {
                      value: validation,
                      message: t("services.copyright.form.validation.0"),
                    },
                  })}
                />
                <span className="text-danger text-small d-block mb-2">
                  {errors?.signatureRepresentant?.message}
                </span>
              </div>
              firma en representación de los autores de la Obra
              <div>
                <input
                  type="text"
                  placeholder="Nombre de la Obra"
                  name="signatureWorkName"
                  defaultValue={
                    defaultValues?.signatureRepresentant?.workname || ""
                  }
                  ref={register({
                    required: {
                      value: validation,
                      message: t("services.copyright.form.validation.0"),
                    },
                  })}
                />
                <span className="text-danger text-small d-block mb-2">
                  {errors?.signatureWorkName?.message}
                </span>
              </div>{" "}
              el{" "}
              <div>
                <input
                  type="date"
                  className="date"
                  placeholder="Fecha de firma"
                  name="signatureRepresentantDate"
                  defaultValue={
                    defaultValues?.signatureRepresentant?.date || ""
                  }
                  ref={register({
                    required: {
                      value: validation,
                      message: t("services.copyright.form.validation.0"),
                    },
                  })}
                />
                <span className="text-danger text-small d-block mb-2">
                  {errors?.signatureRepresentantDate?.message}
                </span>
              </div>
            </div>
          )}
        </div>
        <div className="buttonsContainer">
          <button
            className="button1"
            type="submit"
            style={{ width: "200px", marginBottom: "8%" }}
            onClick={() => {
              setValidation(false);
              setIsLoadingButton("draft");
            }}
          >
            {isLoadingButton === "draft" ||
            (isLoadingButton === "loading" && !validation)
              ? "Guardando..."
              : t("services.copyright.form.buttons.0")}
          </button>
          <button
            className="button2"
            type="submit"
            style={{ width: "200px", marginBottom: "8%" }}
            onClick={() => {
              setValidation(true);
              setIsLoadingButton("created");
            }}
          >
            {isLoadingButton === "created" ||
            (isLoadingButton === "loading" && validation)
              ? "Guardando..."
              : t("services.copyright.form.buttons.1")}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AutoriaForm;
